import { MODULE_LINK_TYPE, MT_MODULES } from '../constants';
export const ADMIN = {
  [MODULE_LINK_TYPE.BUILD]: (moduleId: string, seriesId: string) =>
    `/ui/coaching/${MT_MODULES.VIDEO_PITCH_COACHING}/admin/${seriesId}/${moduleId}/build`,
  [MODULE_LINK_TYPE.INVITE_TRACK]: (moduleId: string, seriesId: string) =>
    `/ui/coaching/${MT_MODULES.VIDEO_PITCH_COACHING}/admin/${seriesId}/${moduleId}/invite-track`,
  [MODULE_LINK_TYPE.ANALYTICS]: (moduleId: string, seriesId: string, moduleName: string) =>
    `modules/${moduleId}/mission/video_pitch_coaching/overview?gameType=video_pitch_coaching&inSeries=${seriesId}&name=${moduleName}`,
};

export const LEARNER = {};
